import React, { useState } from "react";
import {
    Modal,
    Box,
    Grid,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    Checkbox,
    TextField,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Backdrop,
    CircularProgress,
} from "@mui/material";

// import { postISBARAudit } from "../../services/Sample/ISBARAuditServices";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import { ISBARAuditListing, postISBARAudit } from "../../../services/cliinicalChartServices/AllAuditServices";
import { successAlert } from "../../../../common/components/Toasts/Toasts";
import CommonDynamicTablePaginationNew from "../../../../common/components/CommonTable/CommonDynamicTablePaginationNew";


const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxHeight: "90vh",
    overflow: "auto",
    bgcolor: "background.paper",
    border: "1px solid gray",
    borderRadius: 2,
    boxShadow: 20,
    p: 3,
};

export default function ISBARAuditModel(props) {

    const [auditData, setAuditData] = useState(
        Array.from({ length: 30 }, (_, index) => ({
            id: index + 1,
            status: "",
            incompleteReason: "",
            notDoneReason: "",
        }))
    );

    const [openPost, setOpenPost] = useState(false);
    const [pendingData, setPendingData] = useState(null);
    const [dataResult, setDataResult] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(false);
const userInfo=JSON.parse(localStorage?.getItem("userInfo"))
console.log("userInfouserInfouserInfo",userInfo?.userId);
    const handleOpenPost = () => {
        setOpenPost(true);
    };

    const handleClosePost = () => {
        setOpenPost(false);
    };

    const handleStatusChange = (index, status) => {
        const updated = [...auditData];
        updated[index].status =
            updated[index].status === status ? "" : status;

        if (status === "Complete") {
            updated[index].incompleteReason = "";
            updated[index].notDoneReason = "";
        }

        setAuditData(updated);
    };

    const [tableData, setTableData] = useState([]);
    const handleIncompleteReasonChange = (index, value) => {
        const updated = [...auditData];
        updated[index].incompleteReason = value;
        setAuditData(updated);
    };

    const handleNotDoneReasonChange = (index, value) => {
        const updated = [...auditData];
        updated[index].notDoneReason = value;
        setAuditData(updated);
    };

    const handleSubmit = () => {

        const saveObj = {
            checkIsBARComplete:
                auditData[0]?.status === "Complete",
            checkIsBARIncomplete:
                auditData[0]?.status === "Incomplete",
            checkIsBARReason:
                auditData[0]?.incompleteReason || "",
            checkIsBARNotDone:
                auditData[0]?.status === "Not Done",
            checkIsBARNotDoneReason:
                auditData[0]?.notDoneReason || "",
            admissionId: props?.displayInfo?.AdmissionId,
            addedBy: userInfo?.userId,
        };

        setPendingData(saveObj);

        handleOpenPost();
    };

    const addRecord = async () => {

        const saveObj = {
            checkIsBARComplete:
                auditData[0]?.status === "Complete",
            checkIsBARIncomplete:
                auditData[0]?.status === "Incomplete",
            checkIsBARReason:
                auditData[0]?.incompleteReason || "",
            checkIsBARNotDone:
                auditData[0]?.status === "Not Done",
            checkIsBARNotDoneReason:
                auditData[0]?.notDoneReason || "",
          admissionId: props?.displayInfo?.AdmissionId,
            addedBy: userInfo?.userId,
        };


        console.log("API CALLING");

        setLoading(true);


        try {

            const response =
                await postISBARAudit(
                    saveObj
                );
            console.log(
                "API Response :",
                response.data
            );
            successAlert(
                response?.data?.result
            );
            handleClear();
            populateTable();
            handleClosePost();

        } catch (error) {
            console.error(
                "API Error :",
                error
            );
        } finally {
            setLoading(false);
        }
    };
    const populateTable = async () => {

        try {

            const response =
                await ISBARAuditListing(props?.displayInfo?.AdmissionId);

            console.log(
                "Listing Response :",
                response.data
            );

            const formattedData =
                response?.data?.result?.map(
                    (item) => ({
                        ...item,

                        ISBARComplete:
                            item.ISBARComplete === true
                                ? <span style={{ color: "green", fontWeight: "bold", }}>✔</span>
                                : "",

                        ISBARInComplete:
                            item.ISBARInComplete === true
                                ? <span style={{ color: "green", fontWeight: "bold", }}>✔</span>
                                : "",

                        ISBARNotDone:
                            item.ISBARNotDone === true
                                ? <span style={{ color: "green", fontWeight: "bold", }}>✔</span>
                                : "",
                    })
                );

            setDataResult(
                formattedData || []
            );

        } catch (error) {

            console.error(
                "Listing Error :",
                error
            );
        }
    };

    React.useEffect(() => {
        populateTable();
    }, []);

    const handleClear = () => {
        setAuditData(
            Array.from({ length: 30 }, (_, index) => ({
                id: index + 1,
                status: "",
                incompleteReason: "",
                notDoneReason: "",
            }))
        );
    };

    return (
        <div>
            <Modal open={props.open}
                onClose={props.handleClose}>
                <Box sx={ModalStyle}>
                    <CancelPresentationIconButton onClick={props.handleClose} />

                    <fieldset className="text-left py-2 rounded border border-grey-100 p-3">
                        <legend className="px-3 font-bold text-gray-800">
                            ISBAR Audit
                        </legend>

                        <div
                            style={{
                                display: "flex",
                                gap: "20px",
                                width: "100%",
                                marginTop: "10px",
                            }}
                        >

                            <div
                                style={{
                                    width: "30%",
                                    border: "1px solid #dcdcdc",
                                    borderRadius: "10px",
                                    padding: "20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    // height: "420px",
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        mb: 2, fontWeight: "bold", fontSize: "18px",
                                    }}
                                >
                                    ISBAR
                                </Typography>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "5px",
                                    }}
                                >

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData[0]?.status === "Complete"}
                                                onChange={() =>
                                                    handleStatusChange(0, "Complete")
                                                }
                                            />
                                        }
                                        label="Complete"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData[0]?.status === "Incomplete"}
                                                onChange={() =>
                                                    handleStatusChange(0, "Incomplete")
                                                }
                                            />
                                        }
                                        label="Incomplete"
                                    />

                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={auditData[0]?.status === "Not Done"}
                                                onChange={() =>
                                                    handleStatusChange(0, "Not Done")
                                                }
                                            />
                                        }
                                        label="Not Done"
                                    />

                                </div>
                                <div
                                    style={{
                                        minHeight: "50px",
                                        marginTop: "10px",
                                    }}
                                >
                                    {auditData[0]?.status === "Incomplete" && (
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Incomplete Reason"
                                            value={auditData[0]?.incompleteReason}
                                            onChange={(e) =>
                                                handleIncompleteReasonChange(0, e.target.value)
                                            }
                                        />
                                    )}

                                    {auditData[0]?.status === "Not Done" && (
                                        <TextField
                                            fullWidth
                                            size="small"
                                            label="Not Done Reason"
                                            value={auditData[0]?.notDoneReason}
                                            onChange={(e) =>
                                                handleNotDoneReasonChange(0, e.target.value)
                                            }
                                        />
                                    )}
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        gap: "10px",
                                        marginTop: "auto",
                                        paddingTop: "10px",
                                    }}
                                >

                                    <button
                                        onClick={handleClear}
                                        style={{
                                            padding: "6px 15px",
                                            border: "1px solid red",
                                            backgroundColor: "white",
                                            color: "red",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Clear
                                    </button>

                                    <button
                                        onClick={handleSubmit}
                                        style={{
                                            padding: "7px 15px",
                                            border: "none",
                                            backgroundColor: "#22c55e",
                                            color: "white",
                                            borderRadius: "5px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        Submit
                                    </button>

                                </div>
                            </div>

                            <div
                                style={{
                                    width: "70%",
                                }}
                            >

                                <Typography
                                    variant="h6"
                                    sx={{ fontWeight: "bold", fontSize: "18px", }}
                                >
                                    ISBAR Audit Trail
                                </Typography>

                                {
                                    dataResult?.length > 0 ? (
                                        <div
                                            style={{
                                                height: "320px",
                                                overflow: "auto",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "6px",
                                                padding: 0,
                                                margin: 0,
                                            }}
                                        >
                                            <CommonDynamicTablePaginationNew
                                                dataResult={dataResult}
                                                renderActions={() => null}
                                                removeHeaders={["id"]}
                                                populateTable={populateTable}
                                                actionsRequired={false}
                                                highlightRow={false}
                                            />
                                        </div>
                                    ) : (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: "300px",
                                                fontSize: "16px",
                                                color: "#9ca3af",
                                            }}
                                        >
                                            No Records Found...
                                        </div>
                                    )
                                }

                            </div>
                        </div>

                    </fieldset>
                </Box>
            </Modal>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: 9999,
                }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <ConfirmationModal
                confirmationOpen={openPost}
                confirmationHandleClose={handleClosePost}
                confirmationSubmitFunc={addRecord}
                confirmationLabel="Confirmation"
                confirmationMsg="Are you sure you want to submit this record ?"
                confirmationButtonMsg="Submit"
            />
        </div>
    );
}